import { eventBus } from 'globalState/global-state.js';

$('.modal-close').on('click', function () {
    closeModal($(this).parents('.modal-overlay'));
});

$('.modal-overlay').on('click', function (e) {
    if (
        $(e.target).hasClass('modal-overlay') ||
        $(e.target).hasClass('cart-modal__close')
    ) {
        closeModal($(this));
    }
});

function closeModal($element) {
    $element.fadeOut();
    $('html').css('overflow', 'auto');
    $('body').css('overflowY', 'auto').removeClass('hidden');
    $('body').css('overflowY', '');

    $('.cart-add').show();
    $('.cart-added').remove();
    $('.cart-modal__add').show();

    eventBus.handleCloseModal.broadcast();
}
